import { render, staticRenderFns } from "./LeadEmailsChips.vue?vue&type=template&id=c7915138&"
import script from "./LeadEmailsChips.vue?vue&type=script&lang=js&"
export * from "./LeadEmailsChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports